export const MAX_RECORDING_DAYS = '14'
export const ADVANCED_SUBSCRIPTION_ID = 1
export const CORE_ACCOUNT_ID = 2
